const NumbersFormattingMixin = {
  methods: {
    numberFormatting(num = 0) {
      /* eslint-disable */
      let parts = num.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts.join(".");
      /* eslint-enable */
    },
  },
};

export default NumbersFormattingMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/numbersFormatting.js